export default __webpack_public_path__ + "static/media/doctors-cuate.7a075de4.svg";